"use client";

import { useEffect } from "react";
import Link from "next/link";
import { usePostHogAnalytics } from "@/contexts/PostHogAnalyticsContext";

/**
 * Explicit 404 route (previously Next's default). Fires a dedicated
 * `page_not_found` event with the attempted path so broken links show up in
 * analytics under route_group=not_found instead of hiding in `other`.
 */
export default function NotFound() {
  const { trackAnalyticsEvent } = usePostHogAnalytics();

  useEffect(() => {
    trackAnalyticsEvent("page_not_found", {
      attempted_path:
        typeof window !== "undefined" ? window.location.pathname : null,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-center justify-center px-4 text-center">
      <p className="text-sm font-semibold uppercase tracking-wider text-slate-400">
        Page not found
      </p>
      <h1 className="mt-2 text-2xl font-bold text-slate-900">
        We couldn&apos;t find that page
      </h1>
      <p className="mt-2 text-sm text-slate-500">
        The link may be broken or the page may have moved. Try searching for
        a property instead.
      </p>
      <Link
        href="/properties"
        className="mt-6 rounded-xl bg-[#153e46] px-6 py-3 text-sm font-semibold text-white"
      >
        Browse properties
      </Link>
    </main>
  );
}
